var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 209,
    viewBox: "0 0 344 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.4449V208.445H343C343.333 206.445 342.8 202.645 342 199.445C341 195.445 342 190.445 335 172.945C328 155.445 320 137.445 310.5 122.945C301 108.445 280.5 85.4448 272 76.9448C263.5 68.4448 238.5 49.4448 232 45.4448C225.5 41.4448 196.5 25.4448 184 20.9448C171.5 16.4448 140 5.44488 112 1.94488C84 -1.55512 66 0.444876 47.5 1.94488C32.7 3.14488 9.66667 10.1115 0 13.4449Z",
    fill: "url(#paint0_linear_30_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_4",
    x1: 69,
    y1: 12,
    x2: 227,
    y2: 208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#258AEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.470148,
    stopColor: "#2441EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0102FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorBottom);
export default __webpack_public_path__ + "static/media/VectorBottom.3ee35d578df5fb5b05d39eb5644c7426.svg";
export { ForwardRef as ReactComponent };